import { FC, SyntheticEvent } from 'react';

import { Attachment } from '@playq/services-beetle';

import { CollectionTable } from '/shared/Table/CollectionTable';
import { AttachmentPagination, AttachmentPaginationActions, ICollectionTableColumn } from '/shared/Table';
import { formatDate } from '/helpers';
import { IBaseSort } from '/common/models';
import { searchGlobalAttachmentQueryKeys } from '/api';

import { IAttachmentsTableProps } from '../../IssuesSupportRequests/components/tables/types';
import { fieldIdCSS, fieldTypeCSS, tableStyles } from '../../styles';
import { goToAttacmentURL } from '../../shared';
import { useAttachmentsExpired } from '../../hook';

const Table = CollectionTable.ofType<Attachment, string, string, IBaseSort<string>>();

export const AttachmentsTable: FC<IAttachmentsTableProps> = ({ queryAttachments, initialQuery, onQueryChange }) => {
  const { dataUpdatedAt, isLoading } = queryAttachments;
  const columns: ICollectionTableColumn<Attachment>[] = [
    {
      label: 'ID',
      queryKey: 'id',
      render: ({ id }) => id.id,
      styles: { cell: fieldIdCSS },
    },
    {
      label: 'NAME',
      queryKey: 'name',
      render: ({ name }) => name,
    },
    {
      label: 'Created',
      queryKey: 'created',
      render: ({ createdAt }) => formatDate(createdAt, 'EEE DD t'),
    },
    {
      label: 'TYPE',
      queryKey: 'attachmentType',
      render: ({ attachmentType }) => <div>{attachmentType}</div>,
      styles: { cell: fieldTypeCSS },
    },
  ];
  const { getFreshAttachment } = useAttachmentsExpired({
    updatedAt: dataUpdatedAt,
    queryKeys: searchGlobalAttachmentQueryKeys,
  });
  const handleAttachmentClick = async (_: SyntheticEvent, attachment: Attachment) => {
    const validAttachment = await getFreshAttachment({
      currentAttachment: attachment,
      actionType: 'download',
      notify: true,
    });
    if (validAttachment) {
      goToAttacmentURL(validAttachment.url);
    }
  };

  return (
    <Table
      sortHelper={{ all: [], isValid: () => false }}
      filterHelper={{ all: [], isValid: () => false }}
      columns={columns}
      pending={true}
      initialQuery={initialQuery}
      onQueryChange={onQueryChange}
      onRowClick={handleAttachmentClick}
      data={queryAttachments.attachments}
      processing={isLoading}
      placeholder={{ text: 'There are no attachments' }}
      size='medium'
      total={queryAttachments.total}
      styles={tableStyles({ isAttachments: false })}
      components={{
        Pagination: AttachmentPagination<Attachment>(),
        PaginationActions: AttachmentPaginationActions<Attachment>({ loading: isLoading }),
      }}
    />
  );
};
